import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { stringify } from 'node:querystring';
import { map, switchMap } from 'rxjs/operators';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { mspGlobal } from 'src/app/util/global/mspGlobal';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Injectable({
	providedIn: 'root',
})
export class CustomLabelsService {
	private getCustomLabelUrl = environment.baseApiUrl + 'labels/customLabel?language={qryString}';
	private postCustomLabelUrl = environment.baseApiUrl + 'labels/customLabel';
	private putCustomLabelUrl = environment.baseApiUrl + 'labels/customLabel';
	private getCustomLabelLoadUrl = environment.baseApiUrl + 'labels/customLabel/all';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private profileService: ProfileService,
		private mspGlobal: mspGlobal
	) {}

	getUserLanguage(): Observable<string> {
		return this.profileService.setLocalUser().pipe(
			map((userData) => {
				return userData.language;
			})
		);
	}

	getCustomLabels(): Observable<any> {
		if (Object.keys(this.mspGlobal.labels).length > 0) return of(this.mspGlobal.labels);

		let getCustomLabelUrl = this.getCustomLabelUrl;
		if (this.AuthLoginService.isLoggedIn()) {
			return this.getUserLanguage().pipe(
				switchMap((userLanguage) => {
					const headers = new HttpHeaders({
						Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
						'Content-Type': 'application/json;charset=UTF-8',
					});
					const getcustomLabelUrl = this.getCustomLabelUrl.replace('{qryString}', userLanguage);
					return this.http.get<any>(getcustomLabelUrl, { headers: headers }).pipe(
						map((labels) => {
							this.mspGlobal.labels = labels;
							return this.mspGlobal.labels;
						})
					);
				})
			);
		} else {
			switch (navigator.language.split('-')[0]) {
				case 'pt': {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'Portuguese');
					break;
				}

				case 'es': {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'Spanish');
					break;
				}

				case 'zh': {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'Chinese');
					break;
				}

				case 'chi': {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'Chinese');
					break;
				}

				case 'sk': {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'Slovak');
					break;
				}

				case 'it': {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'Slovak');
					break;
				}

				default: {
					getCustomLabelUrl = getCustomLabelUrl.replace('{qryString}', 'English');
					break;
				}
			}

			return this.http.get<any>(getCustomLabelUrl).pipe(
				map((labels) => {
					this.mspGlobal.labels = labels;
					return this.mspGlobal.labels;
				})
			);
		}
	}

	postCustomLabel(body: any): Observable<string> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.post<any>(this.postCustomLabelUrl, body, { headers: headers }).pipe(
			map((labels) => {
				this.mspGlobal.labels = labels;
				return labels;
			})
		);
	}

	getcustomLabelLoad(): Observable<LabelsInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<LabelsInterface[]>(this.getCustomLabelLoadUrl, { headers: headers }).pipe(
			map((labelLoad) => {
				const newLabelLoad: LabelsInterface[] = [];
				for (const label of labelLoad) {
					const newLabel: LabelsInterface = {
						id: label.id.startsWith('lbl_') ? label.id.slice(4) : label.id,
						portuguese: label.portuguese,
						english: label.english,
						spanish: label.spanish,
						slovak: label.slovak,
						chinese: label.chinese,
						italian: label.italian,
					};

					newLabelLoad.push(newLabel);
				}

				return newLabelLoad;
			})
		);
	}
}
